import ApiClient from './ApiClient';

class ConversationFieldDefinitionsAPI extends ApiClient {
  constructor() {
    super('conversation_field_definitions', { accountScoped: true });
  }

  getAll() {
    return axios.get(this.url);
  }

  create(field) {
    return axios.post(this.url, { field });
  }

  update(id, field) {
    return axios.patch(`${this.url}/${id}`, { field });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(fields) {
    return axios.post(`${this.url}/reorder`, { fields });
  }
}

export default new ConversationFieldDefinitionsAPI();
